import { AmountSuperScript } from "components/design/AmountSuperScript";
import Async from "components/DesignSystem/AsyncComponents/Async";
import Card from "components/DesignSystem/Card/Card";
import { InfoItem } from "components/DesignSystem/InfoItem/InfoItem";
import Select from "components/DesignSystem/Select/Select";
import { Form1099Handler, WForm } from "components/Vendors/VendorColumn";
import { CURRENT_SEASON, VENDOR_SEASON_OPTION } from "constants/vendor";
import { ReactElement, useState } from "react";
import { useGetVendorDetailQuery } from "store/apis/vendors";

type VendorWFormsTabProps = {
  entityId: string;
  groupId: string;
  vendorId: string;
};

export const VendorWFormsTab = ({
  entityId,
  groupId,
  vendorId,
}: VendorWFormsTabProps): ReactElement => {
  const [selectedSeason, setSelectedSeason] = useState(CURRENT_SEASON);

  const { data, isFetching, isSuccess, isError } = useGetVendorDetailQuery(
    { entityId, vendorId, season: selectedSeason },
    { skip: !vendorId || !entityId }
  );

  return (
    <div className="t-flex t-flex-col t-gap-3">
      <div>
        <Select.Root
          size="small"
          onValueChange={setSelectedSeason}
          defaultValue={CURRENT_SEASON}
          value={selectedSeason}
        >
          <Select.Trigger>
            Season: <Select.Value placeholder="select year" />
          </Select.Trigger>
          <Select.Content sideOffset={2}>
            {VENDOR_SEASON_OPTION.map((season) => (
              <Select.Item value={season} key={season}>
                {season}
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Root>
      </div>

      <Async.Root
        isLoading={isFetching}
        isSuccess={isSuccess}
        isError={isError}
        isEmpty={!data}
      >
        <Async.ErrorHandler>
          <div className="t-text-red t-text-body-sm">Something went wrong</div>
        </Async.ErrorHandler>
        <Async.Empty>
          <></>
        </Async.Empty>
        <Async.Success>
          {data && (
            <Card.Root>
              <Card.Body className="t-flex t-flex-col t-gap-5">
                <InfoItem
                  label="1099 Amount"
                  dir="row"
                  className="t-gap-8 t-items-center"
                >
                  <AmountSuperScript amount={data["1099_transaction_amount"]} />
                </InfoItem>
                <InfoItem
                  label="W-Form"
                  dir="row"
                  className="t-gap-8 t-items-center"
                >
                  <div className="t-max-w-sm">
                    <WForm
                      showNotRequired={false}
                      groupId={groupId}
                      season={selectedSeason}
                      vendor={data}
                    />
                  </div>
                </InfoItem>
                <InfoItem
                  label="1099"
                  dir="row"
                  className="t-gap-8 t-items-center"
                >
                  <div className="t-max-w-sm">
                    <Form1099Handler
                      showNotRequired={false}
                      entityId={entityId}
                      season={selectedSeason}
                      vendor={data}
                      groupId={groupId}
                    />
                  </div>
                </InfoItem>
              </Card.Body>
            </Card.Root>
          )}
        </Async.Success>
      </Async.Root>
    </div>
  );
};
